




















































































































































import Component from 'vue-class-component';
import PluginComponent from '../PluginComponent';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { EVENTS } from '@/services/EventBus';
import chroma from 'chroma-js';
import Indicator from '@/models/map-context/Indicator';
import IStat from '@/models/map-context/IStat';
import StyleRule from '@/models/map-context/style/StyleRule';

Chart.plugins.register(ChartDataLabels);

@Component({
  props: {},
  components: {},
})
export default class IndicatorPlugin extends PluginComponent {
  static ID = 'IndicatorPlugin';

  isLoading = false;

  filteredData: Indicator[] = [];

  chartInstances: Chart[] = [];

  selectedFeature = false;
  currentFeature: any = null;
  showFilters = true;

  currentChartHover: any = null;

  /** Couche dont le style a été modifié temporairement au survol du donut */
  hoverStyledLayer: any = null;

  /** Filtre carte figé par clic sur une part / légende du donut (conservé au déplacement carte) */
  pinnedDonutFilter: {
    layerUid: any;
    attributeName: string;
    indicatorLabel?: string;
    title: any;
    titles: any[];
    isOthers: boolean;
  } | null = null;

  static readonly DONUT_MAX_SLICES = 10;

  static readonly DONUT_OTHERS_LABEL = 'Autres';

  static readonly DONUT_OTHERS_COLOR = '#9e9e9e';

  static readonly HOVER_DEBOUNCE_MS = 120;

  hoverDebounceTimer: ReturnType<typeof setTimeout> | null = null;

  featureTitle = 'objet selectionné';

  created() {
    this.getEventBus().$on(EVENTS.MAP_CURRENT_BBOX_CHANGE, this.fetchDatas);
  }

  update() {
    this.fetchDatas();
  }

  resetSearch() {}

  mounted() {
    this.getEventBus().$on(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    this.getEventBus().$on(EVENTS.SELECT_NO_FEATURE, this.cleanSelection);

    if (!this.selectedFeature) {
      this.filteredData = [];
    }

    const selectedFeatures = this.getMapService().selectionService.selectedFeature;
    if (selectedFeatures !== undefined) {
      this.onFeatureSelected(selectedFeatures);
    }
  }

  getDistinctValues(list: any): any[] {
    const distinct = list.filter((item: any, i: any, ar: any) => ar.indexOf(item) === i); // to get distinct values
    return distinct;
  }

  closePanel() {
    this.selectedFeature = false;
    this.getMapService().selectionService.cleanSelection();
    this.getMapService().selectionService.selectFeatures([], false, false); //selectedFeature=null;
  }

  resolveBackgroundColors(item: Indicator, nbColors: number): string[] {
    const safeNbColors = nbColors > 0 ? nbColors : 10;
    const palette = this.contextService.colorPalettes.find(
      (p) => p.name === item.colorPalette
    );
    if (palette) {
      return palette.getColors(safeNbColors);
    }
    if (item.colorPalette) {
      try {
        return chroma.scale(item.colorPalette).colors(safeNbColors);
      } catch (e) {
        console.warn('Palette invalide pour indicateur', item.colorPalette, e);
      }
    }
    return Array(safeNbColors).fill('#cccccc');
  }

  clearSelectionFromChart(chart: any) {
    if (!chart || !chart.data || chart._baseDataLength == null) {
      return;
    }
    const baseLen = chart._baseDataLength;
    chart.data.labels.splice(baseLen);
    chart.data.datasets[0].data.splice(baseLen);
    if (Array.isArray(chart.data.datasets[0].backgroundColor)) {
      chart.data.datasets[0].backgroundColor.splice(baseLen);
    }
  }

  formatDonutTotal(total: number, unit?: string): string {
    if (!Number.isFinite(total)) {
      return unit ? `0 ${unit}` : '0';
    }
    const abs = Math.abs(total);
    let formatted: string;
    if (abs >= 1e6) {
      formatted = `${(total / 1e6).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} M`;
    } else if (abs >= 1e3) {
      formatted = `${(total / 1e3).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} k`;
    } else {
      formatted = total.toLocaleString('fr-FR', { maximumFractionDigits: 2 });
    }
    const trimmedUnit = unit ? String(unit).trim() : '';
    return trimmedUnit ? `${formatted} ${trimmedUnit}` : formatted;
  }

  clearHoverDebounce() {
    if (this.hoverDebounceTimer != null) {
      clearTimeout(this.hoverDebounceTimer);
      this.hoverDebounceTimer = null;
    }
  }

  scheduleDonutHighlight(indicator: Indicator, titles: any[]) {
    this.clearHoverDebounce();
    this.hoverDebounceTimer = setTimeout(() => {
      this.hoverDebounceTimer = null;
      if (this.pinnedDonutFilter) {
        return;
      }
      this.highlightDonutCategories(indicator, titles);
    }, IndicatorPlugin.HOVER_DEBOUNCE_MS);
  }

  scheduleDonutHighlightClear() {
    this.clearHoverDebounce();
    this.hoverDebounceTimer = setTimeout(() => {
      this.hoverDebounceTimer = null;
      if (this.pinnedDonutFilter) {
        return;
      }
      this.clearDonutHighlight(true);
      this.currentChartHover = null;
    }, IndicatorPlugin.HOVER_DEBOUNCE_MS);
  }

  resetDonutFilter() {
    this.clearHoverDebounce();
    this.pinnedDonutFilter = null;
    this.clearDonutHighlight(true);
    this.currentChartHover = null;
  }

  slugifyFileName(value: string): string {
    return String(value || 'indicateur')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9-_]+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '')
      .toLowerCase() || 'indicateur';
  }

  downloadDataUrl(dataUrl: string, fileName: string) {
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadTextFile(content: string, fileName: string, mimeType = 'text/csv;charset=utf-8;') {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    this.downloadDataUrl(url, fileName);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  escapeCsvValue(value: any): string {
    const text = value == null ? '' : String(value);
    if (/[;"\n\r]/.test(text)) {
      return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
  }

  exportChartPng(item: Indicator) {
    const chart: any = item && item.chart;
    if (!chart) {
      return;
    }
    let dataUrl = '';
    if (typeof chart.toBase64Image === 'function') {
      dataUrl = chart.toBase64Image();
    } else if (chart.canvas && typeof chart.canvas.toDataURL === 'function') {
      dataUrl = chart.canvas.toDataURL('image/png');
    }
    if (!dataUrl) {
      return;
    }
    const fileName = `${this.slugifyFileName(item.label || 'indicateur')}.png`;
    this.downloadDataUrl(dataUrl, fileName);
  }

  exportIndicatorCsv(item: Indicator) {
    if (!item) {
      return;
    }
    const unit = item.centerUnit ? String(item.centerUnit).trim() : '';
    const fileName = `${this.slugifyFileName(item.label || 'indicateur')}.csv`;
    let lines: string[] = [];

    if (item.graphType === 'distinct_donut') {
      const stats = Array.isArray(item.stats) ? item.stats : [];
      const total = stats.reduce((sum: number, stat: any) => sum + this.getDonutStatValue(stat), 0);
      lines = [
        ['categorie', 'valeur', 'pourcentage', 'unite'].map((h) => this.escapeCsvValue(h)).join(';'),
      ];
      stats
        .map((stat: any) => {
          const value = this.getDonutStatValue(stat);
          const percent = total > 0 ? (value / total) * 100 : 0;
          return {
            title: stat.title,
            value,
            percent,
          };
        })
        .sort((a, b) => b.percent - a.percent)
        .forEach((row) => {
          lines.push([
            this.escapeCsvValue(row.title),
            this.escapeCsvValue(row.value),
            this.escapeCsvValue(row.percent.toLocaleString('fr-FR', { maximumFractionDigits: 2 })),
            this.escapeCsvValue(unit),
          ].join(';'));
        });
      lines.push([
        this.escapeCsvValue('TOTAL'),
        this.escapeCsvValue(total),
        this.escapeCsvValue(total > 0 ? '100' : '0'),
        this.escapeCsvValue(unit),
      ].join(';'));
    } else if (item.graphType === 'minmaxmean') {
      const stats = item.stats || { min: 0, max: 0, mean: 0, count: 0, sum: 0 };
      lines = [
        ['statistique', 'valeur', 'unite'].map((h) => this.escapeCsvValue(h)).join(';'),
        ['min', stats.min, unit].map((v) => this.escapeCsvValue(v)).join(';'),
        ['max', stats.max, unit].map((v) => this.escapeCsvValue(v)).join(';'),
        ['mean', stats.mean, unit].map((v) => this.escapeCsvValue(v)).join(';'),
        ['count', stats.count, ''].map((v) => this.escapeCsvValue(v)).join(';'),
        ['sum', stats.sum, unit].map((v) => this.escapeCsvValue(v)).join(';'),
      ];
    } else if (item.graphType === 'top_n') {
      const rows = this.getTopNRows(item);
      lines = [
        ['rang', 'label', 'valeur', 'categorie', 'unite'].map((h) => this.escapeCsvValue(h)).join(';'),
      ];
      rows.forEach((row, index) => {
        lines.push([
          this.escapeCsvValue(index + 1),
          this.escapeCsvValue(row.label),
          this.escapeCsvValue(row.value),
          this.escapeCsvValue(row.category || ''),
          this.escapeCsvValue(unit),
        ].join(';'));
      });
    } else {
      return;
    }

    // BOM UTF-8 pour Excel
    this.downloadTextFile(`\uFEFF${lines.join('\n')}\n`, fileName);
  }

  getDonutStatValue(stat: any): number {
    const value = Number(stat && (stat.value != null ? stat.value : stat.count));
    return Number.isFinite(value) ? value : 0;
  }

  getTopNRows(item: Indicator): Array<{
    label: string;
    value: number;
    featureKey: string;
    color: string;
    category?: string;
  }> {
    if (!item || !item.isTopN() || !Array.isArray(item.stats)) {
      return [];
    }
    const colors = this.resolveBackgroundColors(item, Math.max(item.stats.length, 1));
    return item.stats.map((row: any, index: number) => ({
      label: String(row.label || 'Sans nom'),
      value: Number(row.value) || 0,
      featureKey: String(row.featureKey || ''),
      color: row.color || colors[index % colors.length] || '#5b8def',
      category: row.category,
    }));
  }

  getFeatureKey(feature: any): string {
    if (!feature) {
      return '';
    }
    if (feature.ol_uid != null) {
      return `ol:${feature.ol_uid}`;
    }
    const id = typeof feature.getId === 'function' ? feature.getId() : null;
    if (id != null && id !== '') {
      return `id:${id}`;
    }
    return '';
  }

  findTopNFeature(item: Indicator, featureKey: string): any {
    if (!item || !item.layer || !featureKey) {
      return null;
    }
    const source = item.layer.getLayerSource && item.layer.getLayerSource();
    if (!source || typeof source.getFeatures !== 'function') {
      return null;
    }
    const features = source.getFeatures() || [];
    return features.find((feature: any) => this.getFeatureKey(feature) === featureKey) || null;
  }

  isTopNRowSelected(row: { featureKey?: string }): boolean {
    if (!this.currentFeature || !row || !row.featureKey) {
      return false;
    }
    return this.getFeatureKey(this.currentFeature) === row.featureKey;
  }

  onTopNRowClick(item: Indicator, row: { featureKey?: string; label?: string; value?: number }) {
    if (!item || !item.layer || !row) {
      return;
    }
    let feature = this.findTopNFeature(item, row.featureKey || '');
    if (!feature) {
      // Fallback : matching label + valeur dans l'emprise courante
      const source = item.layer.getLayerSource && item.layer.getLayerSource();
      const features = source && typeof source.getFeaturesInExtent === 'function'
        ? source.getFeaturesInExtent(this.getMapService().getMapExtent())
        : (source && source.getFeatures ? source.getFeatures() : []);
      const labelAttr = item.labelAttribute || item.attributeName;
      feature = (features || []).find((f: any) => {
        const label = f.get(labelAttr);
        const value = Number(f.get(item.attributeName));
        return String(label || 'Sans nom') === String(row.label || '')
          && Number.isFinite(value)
          && value === Number(row.value);
      }) || null;
    }
    if (!feature) {
      return;
    }
    const selectionService = this.getMapService().selectionService;
    if (!selectionService) {
      return;
    }
    feature.layerConfig = item.layer;
    selectionService.cleanSelection();
    selectionService.addToSelection(feature);
    try {
      const mapService: any = this.getMapService();
      if (typeof mapService.zoomToFeature === 'function') {
        mapService.zoomToFeature(feature);
      }
    } catch (e) {
      // ignore zoom errors (ex. mode 3D)
    }
  }

  openTopNFeatureList(item: Indicator) {
    if (!item || !item.layer) {
      return;
    }
    this.contextService.tablelayer = item.layer;
  }

  formatDonutPercent(percent: number): string {
    return `${percent.toLocaleString('fr-FR', {
      maximumFractionDigits: percent >= 10 ? 0 : 1,
    })} %`;
  }

  buildDonutSlices(item: Indicator): Array<{
    title: any;
    titles: any[];
    value: number;
    percent: number;
    percentLabel: string;
    color: string;
    isOthers: boolean;
  }> {
    if (!item || item.graphType !== 'distinct_donut' || !Array.isArray(item.stats) || item.stats.length === 0) {
      return [];
    }
    const stats = item.stats;
    const total = stats.reduce((sum: number, stat: any) => sum + this.getDonutStatValue(stat), 0);
    if (total <= 0) {
      return [];
    }

    const colors = item.useColorFromAnalyse
      ? stats.map((stat: any) => stat.color || '#cccccc')
      : this.resolveBackgroundColors(item, Math.max(stats.length, item.nbColors || 10));

    const sorted = stats
      .map((stat: any, index: number) => {
        const value = this.getDonutStatValue(stat);
        const percent = (value / total) * 100;
        return {
          title: stat.title,
          titles: [stat.title],
          value,
          percent,
          percentLabel: this.formatDonutPercent(percent),
          color: colors[index % colors.length] || '#cccccc',
          isOthers: false,
        };
      })
      .sort((a, b) => b.percent - a.percent);

    const maxSlices = IndicatorPlugin.DONUT_MAX_SLICES;
    if (sorted.length <= maxSlices) {
      return sorted;
    }

    const topCount = maxSlices - 1;
    const top = sorted.slice(0, topCount);
    const rest = sorted.slice(topCount);
    const othersValue = rest.reduce((sum, entry) => sum + entry.value, 0);
    const othersPercent = (othersValue / total) * 100;
    top.push({
      title: IndicatorPlugin.DONUT_OTHERS_LABEL,
      titles: rest.map((entry) => entry.title),
      value: +othersValue.toFixed(2),
      percent: othersPercent,
      percentLabel: this.formatDonutPercent(othersPercent),
      color: IndicatorPlugin.DONUT_OTHERS_COLOR,
      isOthers: true,
    });
    return top;
  }

  getDonutLegendItems(item: Indicator) {
    if ((item as any).donutSlices) {
      return (item as any).donutSlices;
    }
    return this.buildDonutSlices(item);
  }

  getIndicatorLayerUid(item: Indicator): any {
    return item && item.layer ? item.layer.uid : null;
  }

  isPinnedIndicator(item: Indicator): boolean {
    if (!this.pinnedDonutFilter || !item) {
      return false;
    }
    return this.getIndicatorLayerUid(item) === this.pinnedDonutFilter.layerUid
      && item.attributeName === this.pinnedDonutFilter.attributeName
      && (item.label || '') === (this.pinnedDonutFilter.indicatorLabel || '');
  }

  isDonutPinned(item: Indicator, entry: any): boolean {
    return this.isPinnedIndicator(item)
      && !!this.pinnedDonutFilter
      && this.valuesMatch(this.pinnedDonutFilter.title, entry.title);
  }

  findPinnedIndicator(): Indicator | null {
    if (!this.pinnedDonutFilter) {
      return null;
    }
    const pinned = this.pinnedDonutFilter;
    return this.filteredData.find((item) =>
      item.graphType === 'distinct_donut'
      && this.getIndicatorLayerUid(item) === pinned.layerUid
      && item.attributeName === pinned.attributeName
      && (item.label || '') === (pinned.indicatorLabel || '')
    ) || null;
  }

  reapplyPinnedDonutFilter() {
    if (!this.pinnedDonutFilter) {
      return;
    }
    const indicator = this.findPinnedIndicator();
    if (!indicator) {
      return;
    }
    const slices = this.getDonutLegendItems(indicator);
    const matchingSlice = slices.find((slice: any) =>
      this.valuesMatch(slice.title, this.pinnedDonutFilter!.title)
    );
    if (matchingSlice) {
      this.pinnedDonutFilter = {
        ...this.pinnedDonutFilter,
        title: matchingSlice.title,
        titles: matchingSlice.titles,
        isOthers: matchingSlice.isOthers,
      };
      this.highlightDonutCategories(indicator, matchingSlice.titles);
      return;
    }
    // La catégorie n'apparaît plus dans le donut (hors emprise),
    // on conserve le filtre et on continue de filtrer la carte.
    this.highlightDonutCategories(indicator, this.pinnedDonutFilter.titles);
  }

  toggleDonutPin(item: Indicator, entry: any) {
    this.clearHoverDebounce();
    if (this.isDonutPinned(item, entry)) {
      this.resetDonutFilter();
      return;
    }
    this.pinnedDonutFilter = {
      layerUid: this.getIndicatorLayerUid(item),
      attributeName: item.attributeName,
      indicatorLabel: item.label,
      title: entry.title,
      titles: entry.titles || [entry.title],
      isOthers: !!entry.isOthers,
    };
    this.highlightDonutCategories(item, this.pinnedDonutFilter.titles);
  }

  onDonutLegendEnter(item: Indicator, entry: any) {
    if (this.pinnedDonutFilter) {
      return;
    }
    this.scheduleDonutHighlight(item, entry.titles || [entry.title]);
  }

  onDonutLegendLeave() {
    if (this.pinnedDonutFilter) {
      return;
    }
    this.scheduleDonutHighlightClear();
  }

  getDonutCenterTotalPlugin() {
    const self = this;
    return {
      afterDraw(chart: any) {
        if (!chart || chart.config.type !== 'doughnut') {
          return;
        }
        const dataset = chart.data && chart.data.datasets && chart.data.datasets[0];
        if (!dataset || !Array.isArray(dataset.data)) {
          return;
        }
        const baseLen = chart._baseDataLength != null ? chart._baseDataLength : dataset.data.length;
        let total = 0;
        for (let i = 0; i < baseLen; i += 1) {
          const value = Number(dataset.data[i]);
          if (Number.isFinite(value)) {
            total += value;
          }
        }
        const indicator = chart.indicator as Indicator | undefined;
        const text = self.formatDonutTotal(total, indicator && indicator.centerUnit);
        const ctx = chart.ctx;
        const chartArea = chart.chartArea;
        const centerX = chartArea
          ? (chartArea.left + chartArea.right) / 2
          : chart.width / 2;
        const centerY = chartArea
          ? (chartArea.top + chartArea.bottom) / 2
          : chart.height / 2;
        const areaHeight = chartArea ? chartArea.bottom - chartArea.top : chart.height;
        const fontSize = Math.max(12, Math.min(22, areaHeight / 7));

        ctx.save();
        ctx.font = `bold ${fontSize}px sans-serif`;
        ctx.fillStyle = '#222';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, centerX, centerY);
        ctx.restore();
      },
    };
  }

  valuesMatch(a: any, b: any): boolean {
    if (a == null && b == null) {
      return true;
    }
    if (a == null || b == null) {
      return false;
    }
    if (String(a) === String(b)) {
      return true;
    }
    const numA = Number(a);
    const numB = Number(b);
    return Number.isFinite(numA) && Number.isFinite(numB) && numA === numB;
  }

  findStyleRulesForCategory(layer: any, indicator: Indicator, categoryValue: any): StyleRule[] {
    if (!layer || !layer.complexStyle || !Array.isArray(layer.complexStyle.styleRules)) {
      return [];
    }
    const attributeName = indicator.attributeName;
    const exactFilters = [
      `${attributeName}='${categoryValue}'`,
      `${attributeName}=${categoryValue}`,
      `${attributeName} = '${categoryValue}'`,
      `${attributeName} = ${categoryValue}`,
    ];
    const candidateRules = typeof layer.complexStyle.getColorRules === 'function'
      ? layer.complexStyle.getColorRules()
      : layer.complexStyle.styleRules;
    return candidateRules.filter((rule: StyleRule) => {
      if (rule.label != null && this.valuesMatch(rule.label, categoryValue)) {
        return true;
      }
      if (rule.value && exactFilters.indexOf(rule.value) >= 0) {
        return true;
      }
      return false;
    });
  }

  getFeaturesForCategories(layer: any, indicator: Indicator, categoryValues: any[]): any[] {
    const source = layer && layer.getLayerSource ? layer.getLayerSource() : null;
    if (!source || !categoryValues || categoryValues.length === 0) {
      return [];
    }
    const extent = this.getMapService().getMapExtent();
    const features = typeof source.getFeaturesInExtent === 'function'
      ? source.getFeaturesInExtent(extent)
      : (typeof source.getFeatures === 'function' ? source.getFeatures() : []);

    const matchedRules = categoryValues.reduce((rules: StyleRule[], categoryValue: any) => {
      return rules.concat(this.findStyleRulesForCategory(layer, indicator, categoryValue));
    }, []);
    const uniqueRules = matchedRules.filter(
      (rule, index, arr) => arr.indexOf(rule) === index
    );

    if (indicator.useColorFromAnalyse && uniqueRules.length > 0) {
      return features.filter((feature: any) =>
        uniqueRules.some((rule: StyleRule) => rule.evaluateFeature(feature))
      );
    }

    const attributeName = indicator.attributeName;
    return features.filter((feature: any) =>
      categoryValues.some((categoryValue) =>
        this.valuesMatch(feature.get(attributeName), categoryValue)
      )
    );
  }

  highlightDonutCategories(indicator: Indicator, categoryValues: any[]) {
    const layer = indicator && indicator.layer;
    const titles = (categoryValues || []).filter(
      (value) => value !== undefined && value !== null && value !== ''
    );
    if (!layer || titles.length === 0) {
      return;
    }

    this.clearDonutHighlight(false);

    const matchedRules = titles.reduce((rules: StyleRule[], categoryValue: any) => {
      return rules.concat(this.findStyleRulesForCategory(layer, indicator, categoryValue));
    }, []);
    const uniqueRules = matchedRules.filter(
      (rule, index, arr) => arr.indexOf(rule) === index
    );

    if (layer.complexStyle && layer.complexStyle.isDefined && layer.complexStyle.isDefined()
      && uniqueRules.length > 0) {
      layer.complexStyle.styleRules.forEach((rule: StyleRule) => {
        const matched = uniqueRules.indexOf(rule) >= 0
          || uniqueRules.some((m) => m.value === rule.value);
        // Garder actives les règles de taille pour préserver la fusion bivariée couleur+taille
        const keepSize = typeof layer.complexStyle.ruleDefinesSize === 'function'
          && layer.complexStyle.ruleDefinesSize(rule);
        rule.active = matched || keepSize;
      });
      layer.updateStyle();
      this.hoverStyledLayer = layer;
    } else if (layer.getOlLayer && layer.getOlLayer() && layer.getOlLayer().setStyle) {
      const attributeName = indicator.attributeName;
      const baseStyleFn = layer.getStyleFunction();
      layer.getOlLayer().setStyle((feature: any, resolution: any) => {
        const featureValue = feature.get(attributeName);
        if (!titles.some((categoryValue) => this.valuesMatch(featureValue, categoryValue))) {
          return null;
        }
        return baseStyleFn(feature, resolution);
      });
      this.hoverStyledLayer = layer;
    }

    const matchingFeatures = this.getFeaturesForCategories(layer, indicator, titles);
    const selectionService = this.getMapService().selectionService;
    if (selectionService && matchingFeatures.length > 0) {
      selectionService.cleanSelection();
      matchingFeatures.forEach((feature: any) => {
        feature.layerConfig = layer;
        selectionService.addToSelection(feature);
      });
    }
  }

  clearDonutHighlight(restoreSelection = true) {
    if (this.hoverStyledLayer) {
      const layer = this.hoverStyledLayer;
      if (layer.complexStyle && Array.isArray(layer.complexStyle.styleRules)) {
        layer.complexStyle.styleRules.forEach((rule: StyleRule) => {
          rule.active = true;
        });
      }
      if (typeof layer.updateStyle === 'function') {
        layer.updateStyle();
      }
      this.hoverStyledLayer = null;
    }

    const selectionService = this.getMapService().selectionService;
    if (!selectionService) {
      return;
    }
    selectionService.cleanSelection();
    if (restoreSelection && this.currentFeature) {
      if (!this.currentFeature.layerConfig && this.currentChartHover
        && this.currentChartHover.indicator
        && this.currentChartHover.indicator.layer) {
        this.currentFeature.layerConfig = this.currentChartHover.indicator.layer;
      }
      if (this.currentFeature.layerConfig) {
        selectionService.addToSelection(this.currentFeature);
      }
    }
  }

  async fetchDatas() {
    this.filteredData = [];

    let layerWithIndictors = this.getMapService()
      .getOrderedLayerList()
      .filter(function (layer) {
        return layer.indicators && layer.indicators.isDefined();
      });
    layerWithIndictors.forEach((layer) => {
      if (layer && layer.isLayerVisible() && layer.inRange(this.getMapService().currentScale)) {
        const source = layer.getLayerSource();
        if (!source || typeof source.getFeaturesInExtent !== 'function') {
          return;
        }
        let indic = layer.indicators.indicators;
        let features = source.getFeaturesInExtent(this.getMapService().getMapExtent());

        indic.forEach((indicator: Indicator) => {
          if (typeof indicator.isVisible === 'function' ? !indicator.isVisible() : indicator.active === false) {
            return;
          }
          indicator.layer=layer;
          indicator.computeStats(features,layer);
          this.filteredData.push(indicator);
        });
      }
    });
    this.renderCharts();
    setTimeout(()=>{
      layerWithIndictors.forEach((layer) => {
            if (layer && layer.isLayerVisible() && layer.inRange(this.getMapService().currentScale)) {
              const source = layer.getLayerSource();
              if (!source || typeof source.getFeaturesAtCoordinate !== 'function') {
                return;
              }
              let mapService: any;
              try {
                mapService = this.getOpenLayersMapService();
              } catch (e) {
                return;
              }
              if (!mapService || !mapService.map) {
                return;
              }
              let featureinCenter = source.getFeaturesAtCoordinate(mapService.map.getView().getCenter());
            
              if (featureinCenter && featureinCenter.length == 1) {
                featureinCenter[0].layerConfig = layer;
                this.onFeatureSelected(featureinCenter,true);
              }else if(this.currentFeature!=null && this.currentFeature.layerConfig === layer){
                this.onFeatureSelected([this.currentFeature],false);
              }
            }
      });
    },200);
   
  }

  beforeDestroy() {
    this.clearHoverDebounce();
    this.pinnedDonutFilter = null;
    this.clearDonutHighlight(false);
    this.getEventBus().$off(EVENTS.MAP_CURRENT_BBOX_CHANGE, this.fetchDatas);
    this.getEventBus().$off(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    this.getEventBus().$off(EVENTS.SELECT_NO_FEATURE, this.cleanSelection);
    this.chartInstances.forEach((chart) => chart.destroy());
    this.chartInstances = [];
  }
  onFeatureSelected(features: any,centerMapSelection=false) {
    console.log(features);
    this.showFilters = false;
    this.selectedFeature = true;
    if (!features || features.length === 0) {
      this.featureTitle = 'indicateurs';
      return;
    }
    this.currentFeature = features[0];

    let selectedlayer = this.currentFeature.layerConfig;
    if (!selectedlayer || !selectedlayer.indicators || !selectedlayer.indicators.indicators) {
      return;
    }
    let indic = selectedlayer.indicators.indicators;
    indic.forEach((indicator: Indicator) => {
      if (typeof indicator.isVisible === 'function' ? !indicator.isVisible() : indicator.active === false) {
        return;
      }
      this.featureTitle = this.currentFeature.get(indicator.labelAttribute);
      if (indicator.isGraph() && (centerMapSelection==false||indicator.showCenterObject) ) {
        let chart = indicator.chart;
        this.$nextTick(() => {
          if (!chart || !chart.data || !chart.data.datasets || !chart.data.datasets[0]) {
            return;
          }
          const valueAttributeName = indicator.usesValueAggregation() && indicator.valueAttribute
            ? indicator.valueAttribute
            : indicator.attributeName;
          const featureValue = Number(this.currentFeature.get(valueAttributeName));
          this.clearSelectionFromChart(chart);
          chart.data.labels.push(this.featureTitle);
          chart.data.datasets[0].data.push(featureValue);
          if(indicator.useColorFromAnalyse && indicator.layer && indicator.layer.complexStyle){
            if (!Array.isArray(chart.data.datasets[0].backgroundColor)) {
              chart.data.datasets[0].backgroundColor = [];
            }
            chart.data.datasets[0].backgroundColor.push(
              indicator.layer.complexStyle.getColorFromAnalyse(featureValue, valueAttributeName)
            );
          }
          chart.update();
        });
      } else if(indicator.isTextArea() && (centerMapSelection==false||indicator.showCenterObject)){
        indicator.currentSelectContent = indicator.replaceContent(
          indicator.textSelectContent || '',
          indicator.stats || {min:0,max:0,mean:0,count:0,sum:0},
          this.currentFeature
        );
      }
    });
  }

  cleanSelection() {
    this.selectedFeature = false;
    this.currentFeature=null;
    this.featureTitle = 'indicateurs';
    this.clearHoverDebounce();
    this.pinnedDonutFilter = null;
    this.clearDonutHighlight(false);
    this.renderCharts();
  }

  renderCharts() {
    this.clearHoverDebounce();
    // Conserve le filtre figé au pan/zoom : on le réapplique après le rendu
    this.clearDonutHighlight(false);
    this.currentChartHover = null;
    this.chartInstances.forEach((chart) => chart.destroy());
    this.chartInstances = [];

    this.$nextTick(() => {
      this.filteredData.forEach((item: Indicator, index) => {
        const graphDiv: any = this.$refs[`graphElement${index}`] as HTMLCanvasElement;
        if (graphDiv && item.isGraph()) {
          graphDiv[0].height = item.graphType === 'distinct_donut' ? 220 : 400;
          const nbColors = item.nbColors || (Array.isArray(item.stats) ? item.stats.length : 10) || 10;
          let backgroundColor = this.resolveBackgroundColors(item, nbColors);
          
          
          if (item.graphType == 'minmaxmean') {


            let stats: IStat = item.stats || {min:0,max:0,mean:0,count:0,sum:0};

            if(item.useColorFromAnalyse && item.layer && item.layer.complexStyle){
              backgroundColor=[stats.min, stats.max, stats.mean].map((val:number)=>{
                return item.layer!.complexStyle.getColorFromAnalyse(val, item.attributeName);
              });
            }
            const chartInstance: any = new Chart(graphDiv, {
              type: 'bar',
              data: {
                labels: ['min', 'max', 'mean'],
                datasets: [
                  {
                    label: item.label,
                    data: [stats.min, stats.max, stats.mean],
                    backgroundColor: backgroundColor,
                    borderWidth: 1,
                  },
                ],
              },
              options: {
                responsive: true,
                legend: {
                  reverse: true,
                  display: false,
                  position: 'bottom',
                },
                plugins: {
                  legend: {
                    maxHeight: 200,
                  },
                  datalabels: {
                    color: '#fff',
                    textShadowColor: '#000',
                    textShadowBlur: 5,
                    textStrokeWidth: 1,
                    textStrokeColor: '#000',
                    //backgroundColor:'#ffffff',
                    anchor: 'center',
                    align: 'center',
                    font: { weight: 'bold' },
                    formatter: (value: any) => value,
                  },
                },
              },
            });
            chartInstance._baseDataLength = 3;
            item.chart = chartInstance;
            this.chartInstances.push(chartInstance);
          } else {
            let self=this;
            const slices = this.buildDonutSlices(item);
            (item as any).donutSlices = slices;
            backgroundColor = slices.map((slice) => slice.color);
            const chartInstance:any = new Chart(graphDiv, {
              type: 'doughnut',
              data: {
                labels: slices.map((slice) => slice.title),
                datasets: [
                  {
                    label: item.label,
                    data: slices.map((slice) => slice.value),
                    backgroundColor: backgroundColor,
                    borderWidth: 1,
                  },
                ],
              },
              plugins: [this.getDonutCenterTotalPlugin()],
              options: {
                responsive: true,
                legend: {
                  reverse: true,
                  display: false,
                  position: 'bottom',
                },
                tooltips: {
                  callbacks: {
                    label(tooltipItem: any) {
                      const sliceIndex = tooltipItem.index;
                      const slice = slices[sliceIndex];
                      if (!slice) {
                        return '';
                      }
                      const valueLabel = self.formatDonutTotal(slice.value, item.centerUnit);
                      return `${slice.title}: ${valueLabel} (${slice.percentLabel})`;
                    },
                  },
                },
                onHover: function(evt,hoveredItems) {
                  if (self.pinnedDonutFilter) {
                    return;
                  }
                  if (hoveredItems.length) {
                    const i:any = hoveredItems[0];
                    const chart = i._chart;
                    const indicator = chart && chart.indicator;
                    if (!indicator || !indicator.layer) {
                      return;
                    }
                    // Ignore la part temporaire ajoutée à la sélection d'un objet
                    if (chart._baseDataLength != null && i._index >= chart._baseDataLength) {
                      return;
                    }
                    const slice = slices[i._index];
                    if (!slice) {
                      return;
                    }
                    if (self.currentChartHover === chart
                      && chart._hoveredCategory != null
                      && self.valuesMatch(chart._hoveredCategory, slice.title)) {
                      return;
                    }
                    self.currentChartHover = chart;
                    chart._hoveredCategory = slice.title;
                    self.scheduleDonutHighlight(indicator, slice.titles);
                  } else if (self.currentChartHover != null) {
                    if (self.currentChartHover) {
                      self.currentChartHover._hoveredCategory = null;
                    }
                    self.scheduleDonutHighlightClear();
                  }
                },
                onClick: function(evt, clickedItems) {
                  const chart: any = this;
                  if (!clickedItems || !clickedItems.length) {
                    if (self.isPinnedIndicator(item)) {
                      self.resetDonutFilter();
                    }
                    return;
                  }
                  const clickedIndex = (clickedItems[0] as any)._index;
                  if (chart._baseDataLength != null && clickedIndex >= chart._baseDataLength) {
                    return;
                  }
                  const slice = slices[clickedIndex];
                  if (slice) {
                    self.toggleDonutPin(item, slice);
                  }
                },
                plugins: {
                  legend: {
                    maxHeight: 200,
                  },
                  datalabels: {
                    color: '#fff',
                    textShadowColor: '#000',
                    textShadowBlur: 5,
                    textStrokeWidth: 1,
                    textStrokeColor: '#000',
                    //backgroundColor:'#ffffff',
                    anchor: 'center',
                    align: 'center',
                    font: { weight: 'bold' },
                    formatter: (value: any) => value,
                  },
                },
              },
            });
            chartInstance._baseDataLength = slices.length;
            item.chart = chartInstance;
            chartInstance.indicator = item;
            this.chartInstances.push(chartInstance);
          }
        }
      });
      this.reapplyPinnedDonutFilter();
    });
  }
}
